export default defineNuxtPlugin((nuxtApp) => {
  // Create an API instance with Nuxt context
  const api = (request, opts = {}) => {
    const config = useRuntimeConfig()

    const headers = {
      'Accept-Language': nuxtApp.$i18n.locale.value,
      ...opts?.headers
    }

    const { headers: _, ...restOpts } = opts

    return $fetch(request, {
      baseURL: config.public.baseURL,
      headers,
      ...restOpts
    })
  }

  // Provide the API instance globally
  return {
    provide: {
      api
    }
  }
})
